module.exports = __webpack_public_path__ + "pnskfsquadron/img/kr-slider-3.jpg?8102a492";